<template>
    <div class="featured-amenities">
        <ul class="top-amenities-stacked" v-if="stackedAmenityList">
            <li class="amenity" v-for="(amenity, amenityIndex) in featuredAmenities" :key="amenityIndex">
                <span class="icon"><i :class="amenity.icon"></i></span>{{ amenity.text }}
            </li>
        </ul>

        <ul class="top-amenities" v-else>
            <li class="amenity" v-for="(amenity, amenityIndex) in limitedAmenityList" :key="amenityIndex">
                <span class="icon"><i :class="amenity.icon"></i></span>{{ amenity.text }}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'FeaturedAmenities',

    data() {
        return {
            featuredAmenities: []
        }
    },

    props: {
        amenityList: Array,
        stackedAmenityList: false
    },

    methods: {
        getFeaturedAmenities() {
            let self = this;
            for(let i = 0; i < self.amenityList.length; i++) {
                let amenityID = self.amenityList[i].id;
                
                let amenity = {
                    icon: '',
                    text: ''
                };

                if (amenityID == '6') { 
                    amenity.icon = 'fa fa-wifi';
                    amenity.text = self.$t('freeInternet');
                    self.featuredAmenities.push(amenity);
                }

                if (amenityID == '13') { 
                    amenity.icon = 'fa fa-paw';
                    amenity.text = self.$t('petsAllowed');
                    self.featuredAmenities.push(amenity);
                }

                if (amenityID == '15' || amenityID == '134' || amenityID == '560') { 
                    amenity.icon = 'fa fa-swimmer';
                    amenity.text = self.$t('swimmingPool');
                    self.featuredAmenities.push(amenity);
                    break;
                }

                if (amenityID == '14') { 
                    amenity.icon = 'fa fa-coffee';
                    amenity.text = self.$t('restaurant');
                    self.featuredAmenities.push(amenity);
                }

                if (amenityID == '10') { 
                    amenity.icon = 'fa fa-parking';
                    amenity.text = self.$t('freeParking');
                    self.featuredAmenities.push(amenity);
                }

                if (amenityID == '9') { 
                    amenity.icon = 'fa fa-dumbbell';
                    amenity.text = self.$t('fitnessCenterSpa');
                    self.featuredAmenities.push(amenity);
                }
            }
        }
    },

    computed: {
        limitedAmenityList() {
            return this.featuredAmenities.slice(0,4);
        }
    },

    mounted() {
        this.getFeaturedAmenities();
    }
}
</script>